import { DELI_ENV_BASE_URL } from '@api/client';
import * as dealService from '@api/deals';
import { ChipIconButton } from '@components/chip-icon-button';
import { useBoolean, vtrUrl } from '@lib/common';
import { EntityType } from '@lib/deals';
import { Button, Chip, Dialog, DialogActions, DialogContent, DialogTitle, Link, MenuItem, Select, Tooltip, Typography } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import { ColDef } from '@material-ui/data-grid';
import CheckCircleIcon from '@material-ui/icons/Check';
import LaunchIcon from '@material-ui/icons/Launch';
import { lightFormat } from 'date-fns/esm';
import { useSnackbar } from 'notistack';
import { ControlledAutoCompleteDesignationField, ControlledAutoCompleteField } from 'pages/deals/deal-form/deal-associated-person/AssociatedPersonDialogContent_v2';
import { useCallback, useEffect, useMemo, useState } from 'react';

const IDENTITY_FUNC: any = () => void 0;

const ToolTiped = props => {
  let value = props.value;
  return (
    <Tooltip title={value}>
      <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>{value}</span>
    </Tooltip>
  );
};

const SelectRow = ({
  row,
  serialize,
  entity = {}
}: {
  row: any;
  serialize?: (row: any) => { name: string; vtr_id: string; type: string };
  entity: any;
}) => {
  const selectRow = row.setPartialEntity || IDENTITY_FUNC;
  const switchBackToContentForm = row?.switchBackToContentForm ?? null;
  
  const isRowSelected = entity?.vtr_id === row?.vtr_id;
  const onClick = useCallback(() => {
    switchBackToContentForm && switchBackToContentForm();
    selectRow(serialize ? serialize(row) : row)
  }, [selectRow]);
  return (
    <ChipIconButton
      size="small"
      icon={<CheckCircleIcon fontSize="inherit" />}
      clickable
      style={{margin:"0 15px 0 0"}}
      onClick={onClick}
      color={isRowSelected ? "secondary" : "primary"}
    />
  );
};

const serializeContent = row => ({
  name: row.title || row.original_title,
  vtr_id: row.vtr_id,
  meta: row,
  type: EntityType.content,
  deal_content_genre: row.genres,
  language: row.lang_names,
  country_of_origin: row.country_names,
  imdb_id: row.content_imdb_id ? row.content_imdb_id : null,
  deal_content_type: row.content_type,
  working_title: null,
  book_name: null,
  deal_season:
    typeof row.content_parts === 'number' && row.content_parts !== 0
      ? '' + row.content_parts
      : null,
  original_title: row.original_title,
});
export const contentColumns = (entity) : ColDef[] => [
  {
    field: 'title',
    headerName: 'Name',
    sortable: true,
    
    valueGetter: (params) => {
      
      if (params.row.title) {
        return params.row.title;
      }
      else{
        return params.row.original_title;
      }
      
    },
    
    renderCell: params => {
      const TooltipValue = (
        <div>
          Title : {params.row.title}
          <br />
          Original Title : {params.row.original_title}
        </div>
      );
      const value = params.row.title || params.row.original_title;
      
      return (
        <Tooltip title={TooltipValue}>
          <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', color: (params.row.content_publish_ready < 0 ? 'red' : '')}}>{value} </span>
        </Tooltip>
      );
    },
    // sortComparator: (params) => params.title.localeCompare(v2.name),
    flex: 1 / 5,
  },
//   { 
//     headerName: 'Title',
//     field: 'title',
//     valueGetter: (params) => {
//       if (params.row.title) {
//         return params.row.content_type;
//       }
//       return params.row.original_title;
//     },
//     width: 500,
//     // type: "string",
//     renderCell: params => {
//       const TooltipValue = (
//         <div>
//           Title : {params.row.title}
//           <br />
//           Original Title : {params.row.original_title}
//         </div>
//       );
//       const value = params.row.title
//       //  || params.row.original_title;

      
//       return (
//         <Tooltip title={TooltipValue}>
//           <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>{value} </span>
//         </Tooltip>
//       );
//     },
//     // sortComparator: (v1, v2) => v1.localeCompare(v2)
//     // sortComparator: titleSorting
// },
  {
    field: 'content_type',
    headerName: 'Type',
    renderCell: params => {
      return (
        <Tooltip title={params.row.content_type}>
          <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', color: (params.row.content_publish_ready < 0 ? 'red' : '')}}>{params.row.content_type} </span>
        </Tooltip>
      );
    },
    flex: 1 / 5,
  },
  { 
    field: 'genres', 
    headerName: 'Genre', 
    flex: 1 / 5 ,
    renderCell: params => {
      return (
        <Tooltip title={params.row.genres}>
          <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', color: (params.row.content_publish_ready < 0 ? 'red' : '')}}>{params.row.genres} </span>
        </Tooltip>
      );
    },
  },
  { 
    field: 'lang_names', 
    headerName: 'Language', 
    sortable: false, flex: 1 / 5,
    renderCell: params => {
      return (
        <Tooltip title={params.row.lang_names}>
          <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', color: (params.row.content_publish_ready < 0 ? 'red' : '')}}>{params.row.lang_names} </span>
        </Tooltip>
      );
    },
  },
  {
    field: 'release_date',
    headerName: 'Year',
    renderCell: params => {
      const date = params.row.release_date;
      const value = date && date !== 'None' ? lightFormat(new Date(date as string), 'yyyy') : date;
      return <ToolTiped {...params} value={value ? value : params.row.production_year} />;
    },
    flex: 1 / 5,
  },
  {
    flex: 1 / 12,
    field: 'actions',
    sortable: false,
    headerName: 'Actions',
    renderCell(props) {
      return (
        <>
          <ChipIconButton
            size="small"
            component={Link}
            color="secondary"
            target="_blank"
            style={{ marginRight: 2 }}
            href={vtrUrl(props.row.vtr_id, EntityType.content)}
            icon={<LaunchIcon fontSize="inherit" />}
            clickable
          />
          <SelectRow row={props.row} serialize={serializeContent} entity={entity}/>
        </>
      );
    },
  },
];

const serializePerson = row => ({
  name: row.name,
  vtr_id: row.vtr_id,
  meta: row,
  type: EntityType.person,
});

const CreateCompanyPersonRelation = ({person,  onRelationCreated, eachAssociatedPersonEdit = false, setEachAssociatedPersonEdit = null})=>{
  const [dialogOpen, openDialog, closeDialog] = useBoolean(false);
  const [OkPressed, setOkPressed] = useState(false);
  const [associatedPerson, setAssociatedPerson] = useState(person);
  const [associatedCompany, setAssociatedCompany] = useState([]);
  const [company, setCompany] = useState<any>();
  const [associatedDesignation, setAssociatedDesignation] = useState("");
  const {enqueueSnackbar, closeSnackbar, } = useSnackbar();
  const [loader, setLoader] = useState(false);

  const personCompPayload = {
    "person_vtr_id": associatedPerson?.id ? associatedPerson?.id : "",
    "company_vtr_id":company?.id ? company?.id : "",
    "designation": associatedDesignation ? associatedDesignation: ""
  }

  useEffect(()=>{
    if(OkPressed){
      if(personCompPayload?.person_vtr_id && personCompPayload?.company_vtr_id){
        setLoader(true);
        dealService.createPersonCompanyRelation(personCompPayload).subscribe({
          next: (res) => {
            enqueueSnackbar('Company Person Relation created!', { variant: 'success' });
             onRelationCreated?.({
      personVtrId: personCompPayload.person_vtr_id,
      personName:associatedPerson?.name,
      companyVtrId: personCompPayload.company_vtr_id,
      designation:personCompPayload.designation,
      relation: personCompPayload
    });
            closeModal()
          },
          error: err => {
            setLoader(false);
            const errMsg = err?.response?.data?.error;
            enqueueSnackbar(`Error creating Company Person relation (${errMsg ? errMsg : err})`, { variant: 'error' });
          },
          complete: () => {
            closeSnackbar("")
            setLoader(false);
            person?.refreshTable();
          },
        })
      }else if(!personCompPayload?.person_vtr_id){
        enqueueSnackbar('Person cannot be empty', { variant: 'error' });
      }else if(!personCompPayload?.company_vtr_id){
        enqueueSnackbar('Company cannot be empty', { variant: 'error' });
      }
      setOkPressed(false);
    }
  },[OkPressed])

  const closeModal = () => {
    setEachAssociatedPersonEdit && setEachAssociatedPersonEdit(false);
    closeDialog();
  }

  useEffect(() => {
    if (eachAssociatedPersonEdit) openDialog();
  }, [eachAssociatedPersonEdit]);

  const onCreateRelationClick = (e)=>{
    e.preventDefault();
    openDialog()
  }

  return <>
  {!eachAssociatedPersonEdit && (
    <div style={{margin: "0 25px 0 10px", height: "33px", backgroundColor:"orange", padding: "0 10px", borderRadius:"4px", color:"white", cursor:"pointer"}} onClick={onCreateRelationClick}>
       Create C2P
    </div>
  )}
  <Dialog
  // Disable transitions to speed up the element interaction
  // and fix multiple addtion on consecutive clicks.
  transitionDuration={0}
  fullWidth
  maxWidth="sm"
  open={dialogOpen}
  onClose={() => {
    setEachAssociatedPersonEdit && setEachAssociatedPersonEdit(false);
    closeDialog();
  }}>
  <DialogTitle>Create Company-Person (C2P) relation</DialogTitle>
  <DialogContent style={{ height: '65vh' }} dividers>
    <>
        <div style={{position:"absolute", top: "40%", left: "43%"}}>
          {loader && <CircularProgress
              size={75}
              color="primary"
          />}
        </div>
        <ControlledAutoCompleteField
          associatedPerson={associatedPerson}
          setAssociatedPerson={setAssociatedPerson}
          associatedCompany={associatedCompany}
          setAssociatedCompany={setAssociatedCompany}
          company={company}
          setCompany={setCompany}
          createCompanyRelation={true}
        />
        <br />
        <br />
        <ControlledAutoCompleteDesignationField
          associatedDesignation={associatedDesignation}
          setAssociatedDesignation={setAssociatedDesignation}
          createCompanyRelation={true}
        />
      </>
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setOkPressed(true)}>Ok</Button>
    <Button
      onClick={closeModal}>
      Cancel
    </Button>
  </DialogActions>
</Dialog>
</>
}

export const personColumns = (entity,onPersonCompanyCreated) : ColDef[] => [
  { field: 'name',
   headerName: 'Name',
   flex: 1/ 8, 
  },
  // {
  //   flex: 1/ 8,
  //   field: 'designation',
  //   headerName: 'Designation',
  // },
  {
    flex: 1 / 8,
    field: 'company_name',
    headerName: 'Company',
    renderCell(props) {
      const [value, setValue] = useState(props?.row?.companies_associated[0]);
      const [companyArray, setCompanyArray] = useState(props?.row?.companies_associated);

      const selectOption = (ent)=>{
        setValue(ent.target.value)
      }

      useEffect(()=>{
        props.row.selectedCompany = value;
      },[value])

      useEffect(()=>{
        setCompanyArray((comp) => [...comp, {
          "PersonCompanyRelation": "",
          "company_vtr_id": "",
          "designation": "",
          "name": "No Company",
          "order_id": 1,
          "person_vtr_id": ""
      }]);
      },[])

      return (
        <>
        <Select
          labelId="entity-select-label"
          id="entity-select"
          value={value}
          label={"select company"}
          onChange={selectOption}>
            {companyArray?.length > 0 && companyArray?.map((comp)=>{
              const currentlyWorking = comp?.currently_working ? <span style={{opacity:"0.6", fontSize:"14px"}}>{`(CW : ${comp?.currently_working})`}</span>:""; 
            return <MenuItem value={comp}>{comp?.name + " "}{currentlyWorking}</MenuItem>
          })}
        </Select>
        </>
      );
    },
  },
  {
    flex: 0.5/ 8,
    field: 'content_count',
    headerName: 'Content Count',
  },
  {
    // flex: 1/ 8,
    field: 'deal_count',
    headerName: 'Deal Count',
    renderCell(props) {
      return props?.row?.vtr_id  && (
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          {(
            <Tooltip title={`Deals: ${props?.row?.deal_count}`}>
              <Link
                href={`${window.location.origin}/deals/search/?filters[0].id=entity_id&filters[0].value.$eq=${props?.row?.vtr_id}`}
                target="_blank">
                <Typography color="primary" variant="h6">
                  {props?.row?.deal_count}
                </Typography>
              </Link>
            </Tooltip>
          )}
        </div>
      )
    }
  },
  {
    // flex: 1 / 8,
    field: 'role_id',
    headerName: 'Known For',
  },
  // { field: 'totalProjects', headerName: 'Total Projects' },
  {
    flex: 2 / 8,
    field: 'actions',
    headerName: 'Actions',
    renderCell(props) {
      const [eachAssociatedPersonEdit, setEachAssociatedPersonEdit] = useState(false);
      return (
        <>
          <SelectRow row={props.row} serialize={serializePerson} entity={entity}/>
          {!props?.row?.isSeller && !entity.isContentPage && <CreateCompanyPersonRelation person={props?.row}  onRelationCreated={entity.onPersonCompanyCreated} eachAssociatedPersonEdit={eachAssociatedPersonEdit} setEachAssociatedPersonEdit={setEachAssociatedPersonEdit}/>}
          {props.row.imdb_id && (
            <Tooltip title="IMDB">
              <a target="_blank" style={{display:"flex"}} href={`https://www.imdb.com/name/${props.row.imdb_id}`}>
                <img style={{height:"30px", width:"30px", marginRight:"20px", borderRadius: "4px", overflow: "hidden",  }} src="/images/imdb.png"/>
              </a>
            </Tooltip>
          )}
          {props.row.person_tmdb_id && (
            <Tooltip title="TMDB">
              <a target="_blank" style={{display:"flex"}} href={`https://www.themoviedb.org/person/${props.row.person_tmdb_id}`}>
                <img style={{height:"30px", width:"30px", marginRight:"20px", borderRadius: "4px", overflow: "hidden",  }} src="/images/tmdb.jpeg"/>
              </a>
            </Tooltip>
          )}
          {props.row.hubspot_id && (
            <Tooltip title="Hubspot">
              <a target="_blank" style={{display:"flex"}} href={`https://app.hubspot.com/contacts/20258191/record/0-1/${props?.row?.hubspot_id}`}>
                <img style={{height:"30px", width:"30px", marginRight:"20px", borderRadius: "4px", overflow: "hidden"}} src="/images/HS_logo.jpeg"/>
              </a>
            </Tooltip>
          )}
          {props.row.linkedin_url && (
            <Tooltip title="Linkedin">
              <a target="_blank" style={{display:"flex"}} href={`${props?.row?.linkedin_url}`}>
                <img style={{height:"30px", width:"30px", marginRight:"20px", borderRadius: "4px", overflow: "hidden",  }} src="/images/linkedin.png"/>
              </a>
            </Tooltip>
          )}
          {props.row.vtr_id && (
            <Tooltip title="Person Master">
            <a target="_blank" style={{display:"flex"}} href={`${DELI_ENV_BASE_URL}/person-management/edit/${props?.row?.vtr_id}`}>
              <img style={{height:"30px", width:"30px", borderRadius: "4px", overflow: "hidden",  }} src="/images/vitrina.png"/>
            </a>
          </Tooltip>
          )}
        </>
      );
    },
  },
];

const serializeCompany = row => ({
  name: row.name,
  vtr_id: row.vtr_id,
  meta: row,
  type: EntityType.company,
});

export const companyColumns = (entity): ColDef[] => [
  {
    field: 'name',
    flex: 3 / 12,
    headerName: 'Name',
    description: 'The Name of the company.',
    renderCell: params => {
      const value = params.row.name;
      const company_color =
        params.row.company_active == 'Inactive' ||
        params.row.company_active == 'inactive' ||
        params.row.company_publish_ready == -1 ||
        params.row.company_types.some(type => type.id == '197')
          ? 'red'
          : 'black';
      const TooltipValue = (
        <div>
          Company Name : {value}
          <br />
          Company Former Name : {params.row.company_former_name}
          <br />
          Company Legal Name : {params.row.vtr_company_legal_name}
        </div>
      );
      return (
        <Tooltip title={TooltipValue}>
          <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', color: company_color }}>
            {value}
          </span>
        </Tooltip>
      );
    },
  },
  {
    field: 'company_aka',
    flex: 2 / 12,
    headerName: 'A.K.A',
    description: 'The AKA of the company.',
  },
  {
    flex: 2 / 12,
    field: 'country_names',
    headerName: 'Country',
    description: 'Countries can be multiple.',
    sortable: false,
  },
  {
    flex: 3 / 12,
    field: 'company_type',
    headerName: 'Type',
    sortable: false,
    description: 'The type of the company',
  },
  {
    field: 'other_office_locations',
    headerName: 'O. Offices',
    description: 'List of other offices',
    renderCell(props) {
      const val = useMemo(
        () =>
          ((props.value as string) || '')
            .split('|')
            .map(i =>
              i
                .split(',')
                .map(s => s.trim())
                .filter(s => s)
                .join(', '),
            )
            .map(s => s.trim())
            .filter(s => s)
            .join(' | '),
        [props.value],
      );
      return <ToolTiped {...props} value={val} />;
    },
  },
  {
    flex: 2 / 12,
    field: 'projects_count',
    headerName: 'Projects (#)',
  },
  {
    flex: 2 / 12,
    field: 'deals',
    headerName: 'Deals (#)',
  },
  {
    flex: 2 / 12,
    field: 'reputation',
    headerName: 'Reputation (#)',
    renderCell(props) {
      const badgeName = props?.row?.reputation_badge?.name || 'N/A';
      const badgeColor = getBadgeColor(badgeName);
      return (
        <Tooltip
          title={
            <>
              Reputation Score: {props?.row?.reputation}
              <br />
              Range: {props?.row?.reputation_badge?.range?.replace('TO', ' – ')}
            </>
          }>
          <Chip
            label={badgeName}
            size="small"
            style={{
              marginRight: 10,
              backgroundColor: badgeColor,
              color: '#fff',
              fontWeight: 500,
            }}
          />
        </Tooltip>
      );
    },
  },
  {
    flex: 1.5 / 12,
    field: '',
    headerName: 'Actions',
    sortable: false,
    renderCell(props) {
      return (
        <>
          <ChipIconButton
            size="small"
            component={Link}
            color="secondary"
            target="_blank"
            style={{ marginRight: 2 }}
            href={vtrUrl(props.row.vtr_id, EntityType.company)}
            icon={<LaunchIcon fontSize="inherit" />}
            clickable
          />
          <SelectRow row={props.row} serialize={serializeCompany} entity={entity} />
        </>
      );
    },
  },
];

export function getBadgeColor(badge?: string): string {
  switch (badge) {
    case 'AAA+':
      return '#2E7D32'; // dark green
    case 'AAA':
      return '#9a399f'; // green
    case 'AA':
      return '#1976D2'; // blue
    case 'A':
      return '#F57C00'; // orange
    default:
      return '#757575'; // grey for N/A
  }
}

const addTooltip = c => {
  if (!c.renderCell) {
    c.renderCell = ToolTiped;
  }
  return c;
};
export const contentToColumns= (custom) => ({
  [EntityType.company]: companyColumns(custom).map(addTooltip),
  [EntityType.content]: contentColumns(custom).map(addTooltip),
  [EntityType.person]: personColumns(custom,
  custom.onPersonCompanyCreated).map(addTooltip)
});

// function is_nonmedia(company_types){
//   company_types.foreach()
// }
